import AppDataService from "./AppDataService";

export default class VisitService {
  // Fetch a full visit (with its visit_note content) by visit id.
  static async getVisitById(visitId) {
    return await AppDataService.get(`visit/${visitId}`);
  }
}
